import _ from "underscore";

import {
	CLOSE_CROSSTABS_BASIC_TOOLTIP,
	CLOSE_CROSSTABS_INFO_TOOLTIP,
	CLEAR_CROSSTABS_SEARCH_INPUT,
	CLEAR_CROSSTABS_STATS,
	CLOSE_NARRATIVE_MODAL,
	END_SHOW_ENTITY_TRANSITION,
	FETCHING_CROSSTABS_DATA,
	HOVER_CROSSTABS_MAP,
	NARRATIVES_TAB_FOCUS_MODE,
	OPEN_CROSSTABS_BASIC_TOOLTIP,
	OPEN_CROSSTABS_INFO_TOOLTIP,
	OPEN_NARRATIVE_MODAL,
	RESET_CROSSTABS_CHARTS,
	SELECT_CROSSTABS_DATE,
	SELECT_CROSSTABS_TOPIC,
	SELECT_NARRATIVE_FACET,
	SELECT_NARRATIVE_MODAL_DATE,
	START_SHOW_ENTITY_TRANSITION,
	TOGGLE_CROSSTABS_PERSPECTIVE,
	UNHOVER_CROSSTABS_MAP,
	UPDATE_CROSSTABS_SEARCH_INPUT,
} from "actions/constants.js";

import { fetchCrosstabsStats, fetchEntityMapStats, fetchNarrativeModalBargraph, fetchNarrativeModalTimeseries } from "actions/fetch";
import { narrativeNavigationOverride } from "actions/navigation.js";

import { addOrRemove, formatPosition } from "@exo/helpers";
// FLAG_ENABLE_MULTIPLE_NARRATIVE_FILTERS - remove when no longer necessary
import { forceArrayToActLikeAnObject, formatNarrativeBarGraph } from "lib/helpers/crosstabsHelpers.js";
import { convertMapCodeToEntityFilter } from "lib/helpers/filterHelpers.js";
import { setStartDate } from "lib/helpers/helpers.js";

export const showCrosstabsStatsFromInput = (value) => {
	return (dispatch) => {
		dispatch(getCrosstabsStatsAndTransition({ entityString: value }));
	};
};
export const showCrosstabsStats = (params) => {
	const { entity } = params;
	document.getElementById("appLayout").scrollTop = 0;
	return (dispatch) => {
		dispatch(getCrosstabsStatsAndTransition({ entityString: entity }));
	};
};
export const getCrosstabsStatsAndTransition = (params) => {
	const { entityString } = params;
	return (dispatch, getState) => {
		dispatch(fetchCrosstabsStats({ entityString }));
		dispatch(fetchEntityMapStats({ entityString }));
		dispatch({
			type: START_SHOW_ENTITY_TRANSITION,
			entity: {
				name: entityString,
				id: entityString,
				// type: "Persons",
				parent: "entities",
			},
		});
		setTimeout(() => {
			dispatch({ type: END_SHOW_ENTITY_TRANSITION });
		}, 1000);
	};
};

export const refetchCrosstabsStats = (entityString) => {
	return (dispatch, getState) => {
		const resetBecauseEntityStringIsEmpty = !entityString;
		if (resetBecauseEntityStringIsEmpty) {
			dispatch({ type: CLEAR_CROSSTABS_STATS });
			setTimeout(() => {
				dispatch({ type: END_SHOW_ENTITY_TRANSITION });
			}, 10);
		} else {
			dispatch({
				type: RESET_CROSSTABS_CHARTS,
				entity: {
					name: entityString,
					id: entityString,
					// type: "Persons",
					parent: "entities",
				},
			});
			dispatch(fetchCrosstabsStats({ entityString }));
			dispatch(fetchEntityMapStats({ entityString }));
		}
	};
};

export const clearCrosstabsSearchInput = () => {
	return {
		type: CLEAR_CROSSTABS_SEARCH_INPUT,
	};
};
export const updateCrosstabsSearchInput = (value) => {
	return {
		type: UPDATE_CROSSTABS_SEARCH_INPUT,
		value,
	};
};

export const selectCrosstabsDate = (dateObject) => {
	return (dispatch) => {
		dispatch(fetchCrosstabsStats({ futureDateObject: dateObject }));
		dispatch(fetchEntityMapStats({ futureDateObject: dateObject }));
		dispatch({ type: SELECT_CROSSTABS_DATE, dateObject });
		dispatch({ type: FETCHING_CROSSTABS_DATA });
	};
};

export const selectCrosstabsTopic = (topic) => {
	return (dispatch) => {
		dispatch(fetchCrosstabsStats({ futureTopic: topic }));
		dispatch(fetchEntityMapStats({ futureTopic: topic }));
		dispatch({ type: SELECT_CROSSTABS_TOPIC, topic });
		dispatch({ type: FETCHING_CROSSTABS_DATA });
	};
};

export const selectCrosstabsTopicFromInit = (topic) => {
	return (dispatch) => {
		// dispatch(fetchCrosstabsStats({ futureTopic: topic }));
		// dispatch(fetchEntityMapStats({ futureTopic: topic }));
		dispatch({ type: SELECT_CROSSTABS_TOPIC, topic });
		// dispatch({ type: FETCHING_CROSSTABS_DATA });
	};
};

export const selectNarrativeFacet = (facet) => {
	console.log("selectNarrativeFacet", facet);
	return (dispatch) => {
		// FLAG_DATA_HANDLING_FACET - add API call here, if going that route
		// dispatch(fetchCrosstabsStats({ futureTopic: topic }));
		// dispatch(fetchEntityMapStats({ futureTopic: topic }));
		dispatch({ type: SELECT_NARRATIVE_FACET, facet });
		// dispatch({ type: FETCHING_CROSSTABS_DATA });
	};
};

export const crossFilterByType = (params) => {
	const { filter, type } = params;
	return (dispatch) => {
		if (type === "narrative") {
			dispatch(crossFilterNarrative(filter));
		} else {
			dispatch(crossFilterEntity(filter));
		}
	};
};
export const crossFilterEntity = (entityObject) => {
	return (dispatch, getState) => {
		const { entityFilters } = getState().crosstabs;
		const futureEntityFilters = addOrRemove(entityFilters, entityObject, "name");
		dispatch(fetchCrosstabsStats({ futureEntityFilters }));
		dispatch(fetchEntityMapStats({ futureEntityFilters }));
		dispatch({ type: CLOSE_CROSSTABS_BASIC_TOOLTIP }); // prevents hanging tooltip
		dispatch({ type: FETCHING_CROSSTABS_DATA });
	};
};
export const crossFilterMap = (stateObject) => {
	return (dispatch, getState) => {
		const { mapLookup } = getState().projectConfig;
		const filterObject = convertMapCodeToEntityFilter({ stateObject, mapLookup });
		dispatch(crossFilterEntity(filterObject));
	};
};
export const crossFilterNarrative = (entityObject) => {
	return (dispatch, getState) => {
		const { narrativeFilters } = getState().crosstabs;

		// FLAG_ENABLE_MULTIPLE_NARRATIVE_FILTERS - use addOrRemove once we're using an array for real
		let futureNarrativeFilters = forceArrayToActLikeAnObject({
			array: narrativeFilters,
			object: entityObject,
			key: "id",
		});
		// const futureNarrativeFilters = addOrRemove(narrativeFilters, entityObject, "id");
		futureNarrativeFilters = futureNarrativeFilters.length === 0 ? [{ id: "narratives" }] : futureNarrativeFilters;

		dispatch(fetchCrosstabsStats({ futureNarrativeFilters }));
		dispatch(fetchEntityMapStats({ futureNarrativeFilters }));
		dispatch({ type: FETCHING_CROSSTABS_DATA });
	};
};
export const clearCrossFilter = () => {
	return (dispatch, getState) => {
		const { currentTopic } = getState().crosstabs;
		dispatch(fetchCrosstabsStats({ futureEntityFilters: [], futureTopic: currentTopic }));
		dispatch(fetchEntityMapStats({ futureEntityFilters: [], futureTopic: currentTopic }));
		dispatch({ type: FETCHING_CROSSTABS_DATA });
	};
};

export const hoverCrosstabsMap = (data, color, startDate, endDate) => {
	return {
		type: HOVER_CROSSTABS_MAP,
		data,
		color,
		startDate,
		endDate,
	};
};
export const unhoverCrosstabsMap = () => {
	return {
		type: UNHOVER_CROSSTABS_MAP,
	};
};

export const openCrosstabsInfoTooltip = (params) => {
	const { position, text, bullets } = params;
	return {
		type: OPEN_CROSSTABS_INFO_TOOLTIP,
		bullets,
		position,
		text,
	};
};
export const toggleCrosstabsInfoTooltip = (params) => {
	const { position, text, bullets } = params;
	return (dispatch, getState) => {
		const { crosstabsTooltipOpen } = getState().commonUI;
		dispatch({
			type: crosstabsTooltipOpen ? CLOSE_CROSSTABS_INFO_TOOLTIP : OPEN_CROSSTABS_INFO_TOOLTIP,
			bullets,
			position,
			text,
		});
	};
};
export const closeCrosstabsInfoTooltip = () => {
	return {
		type: CLOSE_CROSSTABS_INFO_TOOLTIP,
	};
};

export const toggleCrosstabsPerspective = (params) => {
	return (dispatch, getState) => {
		const { perspective } = getState().crosstabs;
		const futurePerspective = perspective === "Source" ? "Audience" : "Source";
		dispatch(fetchCrosstabsStats({ futurePerspective }));
		dispatch(fetchEntityMapStats({ futurePerspective }));
		dispatch({
			type: TOGGLE_CROSSTABS_PERSPECTIVE,
			perspective: futurePerspective,
		});
		dispatch({ type: FETCHING_CROSSTABS_DATA });
	};
};

// ------------ Narrative Modal -----------
export const closeNarrativeModal = () => {
	return (dispatch) => {
		dispatch({ type: CLOSE_NARRATIVE_MODAL });
	};
};
export const openNarrativeModal = (narrativeData) => {
	console.log("openNarrativeModal", narrativeData);
	return (dispatch, getState) => {
		const { crosstabsNarrativeHeaderLabels, crosstabsNarrativeHeaders, desiredCrosstabsNarrativeOrder } = getState().projectConfig;
		const { currentNarrativeFacet, selectedDateRange } = getState().crosstabs;
		dispatch(fetchNarrativeModalTimeseries({ narrative: narrativeData, selectedDateRange }));
		dispatch({
			type: OPEN_NARRATIVE_MODAL,
			narrativeData,
			barGraph: formatNarrativeBarGraph({
				crosstabsNarrativeHeaders,
				currentNarrativeFacet,
				desiredOrder: desiredCrosstabsNarrativeOrder,
				labels: crosstabsNarrativeHeaderLabels,
				narrativeData,
			}),
		});
	};
};
export const selectNarrativeModalDate = (dateObj) => {
	return (dispatch, getState) => {
		// const { crosstabsNarrativeHeaders, desiredCrosstabsNarrativeOrder } = getState().projectConfig;
		const { narrativeModalData } = getState().crosstabs;
		dispatch(fetchNarrativeModalBargraph({ selectedDateRange: dateObj }));
		dispatch(fetchNarrativeModalTimeseries({ narrative: narrativeModalData, selectedDateRange: dateObj }));
		dispatch({
			type: SELECT_NARRATIVE_MODAL_DATE,
			dateObj,
		});
	};
};
// Calls narrativeNavigationOverride with crosstabs data (easier than routing the data to the component just to pass to the function)
export const openNarrativesWithCrosstabData = () => {
	return (dispatch, getState) => {
		const { baselineDateBegin, baselineDateEnd } = getState().base;
		const { entity, entityFilters, mapFilters, narrativeModalCurrentDateRange, narrativeModalData } = getState().crosstabs;

		const customStartDate = setStartDate({ begin: baselineDateBegin, rangeObj: narrativeModalCurrentDateRange, end: baselineDateEnd });
		const entityObj = {
			name: entity.name,
			id: entity.id,
			type: entity.type,
			parent: "keywords",
		};

		dispatch(
			narrativeNavigationOverride({
				narrative: narrativeModalData,
				perspective: "Source",
				currentZoom:
					narrativeModalCurrentDateRange.id === "all"
						? {
								name: "History",
								value: baselineDateEnd - baselineDateBegin,
								begin: baselineDateBegin,
								end: baselineDateEnd,
						  }
						: {
								name: "Custom",
								value: baselineDateEnd - customStartDate,
								begin: customStartDate,
								end: baselineDateEnd,
						  },
				activeFilters: mapFilters,
				// remove mapsFilters
				entityFilters: _.reject(entityFilters, (filter) => {
					return filter.parent === "sourceState";
				}),
				keywords: [entityObj],
				mapHighlightId: false,
				contentFilteredByDate: false,
				// currentFilters:
			})
		);
		dispatch({ type: NARRATIVES_TAB_FOCUS_MODE });
		dispatch({ type: CLOSE_NARRATIVE_MODAL });
	};
};

// ------------ Tooltips ------------
export const barchartOpenTooltip = (params) => {
	const { event, row } = params;
	return (dispatch, getState) => {
		const { totalArticles } = getState().crosstabs;
		dispatch({
			type: OPEN_CROSSTABS_BASIC_TOOLTIP,
			position: formatPosition(event.target),
			text: `${Math.round((row.value / totalArticles) * 10000) / 100}% of articles`,
		});
	};
};
export const barchartCloseTooltip = () => {
	return {
		type: CLOSE_CROSSTABS_BASIC_TOOLTIP,
	};
};
